import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PageContent from "../shared/components/page/page-content";
import PageHeader from "../shared/components/page/page-header";
import PageTitle from "../shared/components/page/page-header/page-title";
import ContactLists from "./contact-lists";
import ContactsTopActions from "./contacts-top-actions";
const Contacts = () => (_jsxs(_Fragment, { children: [_jsxs(PageHeader, { children: [_jsx(PageTitle, { title: "Contact Lists" }), _jsx(ContactsTopActions, {})] }), _jsx(PageContent, { children: _jsx(ContactLists, {}) })] }));
export default Contacts;
